/* global axios */
import ApiClient from '../ApiClient';

class TelegramPersonalChannel extends ApiClient {
  constructor() {
    super('telegram_personal', { accountScoped: true });
  }

  getPersonalSession(inboxId) {
    return axios.get(`${this.baseUrl()}/telegram_personal/session`, {
      params: { inbox_id: inboxId },
    });
  }

  createPersonalSession({ inboxId }) {
    return axios.post(`${this.baseUrl()}/telegram_personal/session`, {
      inbox_id: inboxId,
    });
  }

  submitPersonalPassword({ inboxId, password }) {
    return axios.post(`${this.baseUrl()}/telegram_personal/session/password`, {
      inbox_id: inboxId,
      password,
    });
  }

  submitPersonalCode({ inboxId, code }) {
    return axios.post(`${this.baseUrl()}/telegram_personal/session/code`, {
      inbox_id: inboxId,
      code,
    });
  }

  deletePersonalSession({ inboxId }) {
    return axios.delete(`${this.baseUrl()}/telegram_personal/session`, {
      data: { inbox_id: inboxId },
    });
  }
}

export default new TelegramPersonalChannel();
